/* eslint-disable @typescript-eslint/no-shadow */
import styled, { css } from 'styled-components';
import { AdvancedCard } from '../../AdvancedCard/AdvancedCard';
import { Button } from '../../Button/Button';
import { Heading } from '../../Heading/Heading';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import { QuestionListItem } from 'components/QuestionList/QuestionListItem/QuestionListItem';

const PAGE_MARGIN = '0 30px';

export const StyledPage = styled.div`
  background-color: #FFFFFF;
  min-height: 100vh;
  margin: ${PAGE_MARGIN};
  position: relative;
  display: flex;
  flex-direction: column;
`

export const StyledEmptySpace = styled.div`
  margin-top: 200px;
`

export const StyledPageContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`

export const StyledStepperHeading = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 16.38px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0px;
  margin-bottom: 10px;
`

export const StyledPageHeading = styled.h1`
  font-size: 42px;
  font-weight: 400;
  line-height: 48.3px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0px;
  margin-bottom: 20px;
`

export const StyledPageDescription = styled.p`
  margin: 0px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-bottom: 20px;
`

export const StyledCTAButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
  background-color: #FFFFFF;
  z-index: 3;
`
export const StyledCTAButton = styled(Button)`
  border-radius: 0;
  margin-bottom: 15px;
  width: 100%;
`

export const StyledDownloadButton = styled(Button)`
  border-radius: 0;
  margin-bottom: 15px;
  width: 100%;
`

export const StyledNotificationContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 50px;
  background-color: #EF3C50;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`

export const StyledAlertIcon = styled(SvgIcon)`
  padding-right: 10px;
`

export const StyledAlertMessage = styled.div`
  margin: 0;
  text-align: center;
  vertical-align: middle;
  line-height: 22px;
`
/// STEP 1 STYLING ///

export const StyledTextboxContainer = styled.div`
  width: 100%;
`

/// STEP 2 STYLING ///

export const StyledSolutionArea = styled.div`
  width: 100%;
`

export const AddRowButton = styled.a`
  font-size: 16px;
  text-decoration: none;
  color: #000000;
`;

export const StyledSelectionSolutionArea = styled.div`
  width: 100%;
`

export const StyledSelectSolutionContainer = styled.div<{ $isSelected: boolean }>`
  border: 1px solid #000000;
  min-height: 60px;
  margin-bottom: 20px;
  background-color: ${({ $isSelected }) => $isSelected ? '#E1E8ED' : '#FFFFFF'};
  display: flex;
  align-items: center;
  padding: 10px 20px;
`

export const StyledRowNumberContainer = styled.div`
  width: 39px;
  height: 39px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #E1E8ED;
  flex-shrink: 0;
`

export const StyledSolution = styled.p`
  font-size: 16px;
  margin: 0px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-left: 10px;
  word-break: break-word;
`

// STEP 4 STYLING ///

export const StyledSolutionCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledSolutionCard = styled(AdvancedCard)<{ $isSelected?: boolean }>`
  width: 335px;
  max-width: calc(100vw - 20px);
  min-width: 90%;
  margin-bottom: 20px;
  background-color: #ffffff;
  outline: 8px solid transparent;
  ${({ $isSelected }) => $isSelected && css`
    outline: 8px solid ${props => props.theme.colors.primary.b};
  `
  }
`;

export const StyledSolutionHeading = styled(Heading).attrs({ level: 'h5' })``;

export const StyledItemContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  > p {
    margin: 0;
  }
`

export const StyledSolutionListItem = styled(QuestionListItem)``;

// FINAL PAGE STYLING ///

export const StyledFinalCardContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
`

export const StyledSolutionSubtitle = styled.p`
  margin: 0;
  font-size: 10.09px;
  font-weight: 900;
  line-height: 10.09px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: center;
  margin-bottom: 5px;

`

export const StyledPlanStep = styled.div`
  display: flex;
  margin-bottom: 20px;
`

export const StyledPlanNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  flex-shrink: 0;
`;

export const StyledPlantext = styled.p`
  margin: 0;
  flex: 1;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-left: 10px;
  margin-top: 5px;
  word-break: break-word;
`

export const StyledDivWithLine = styled.div`
  width: 100%;
  border-top: 1px solid #CACACA;
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const StyledFinalPlanStepContainer = styled.div`
  display: flex;
`

export const StyledStepHeading = styled.p`
  margin: 0;
  flex: 1;
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-bottom: 5px;
`